import React from 'react';

// Shared helpers for list renderers

const findFirstPrefixTargetIndex = (children = []) => {
    for (let i = 0; i < (children?.length || 0); i++) {
        const c = children[i];
        if ((c?.type === 'paragraph' || c?.type === 'heading') && (c?.content?.length > 0)) {
            return i;
        }
    }
    return -1;
};

/**
 * Get classification from the first paragraph/heading child of a list item,
 * since only paragraphs and headings carry classification level attributes.
 */
const getClassificationFromChildren = (liNode) => {
    const children = liNode?.content || [];
    for (const child of children) {
        if (child?.type === 'paragraph' || child?.type === 'heading') {
            const level = child?.attrs?.classificationLevel || 'U';
            const distribution = child?.attrs?.distribution || [];
            const compartment = child?.attrs?.compartment || [];

            let result = level;
            if (distribution.length > 0) {
                result += '//' + distribution.join('/');
            }
            if (compartment.length > 0) {
                result += '//' + compartment.join('/');
            }
            return result;
        }
    }
    return 'U';
};

// Ordered list, bullet list and list item renderers. These use a renderNode
// callback passed from NodeRenderer to recursively render children.
export const OrderedList = ({node, highlightedRef, isHighlighted, idx, inTable = false, renderNode}) => {
    if (!node) return null;

    const start = (node.attrs && node.attrs.start) || 1;
    return (
        <ol key={idx} start={start}>
            {(node.content || []).map((li, i) => {
                const firstIdx = findFirstPrefixTargetIndex(li?.content);
                const cls = (li?.content?.length > 0) ? `(${getClassificationFromChildren(li)})` : undefined;
                return (
                    <li key={i}>
                        {(li.content || []).map((c, j) => (
                            renderNode(c, [i, j], {
                                inTable,
                                inListItem: true,
                                prefixText: j === firstIdx ? cls : undefined
                            })
                        ))}
                    </li>
                );
            })}
        </ol>
    );
};

export const BulletList = ({node, idx, inTable = false, renderNode}) => {
    if (!node) return null;

    return (
        <ul key={idx}>
            {(node.content || []).map((li, i) => {
                const firstIdx = findFirstPrefixTargetIndex(li?.content);
                const cls = (li?.content?.length > 0) ? `(${getClassificationFromChildren(li)})` : undefined;
                return (
                    <li key={i}>
                        {(li.content || []).map((c, j) => (
                            renderNode(c, [i, j], {
                                inTable,
                                inListItem: true,
                                prefixText: j === firstIdx ? cls : undefined
                            })
                        ))}
                    </li>
                );
            })}
        </ul>
    );
};

export const ListItem = ({node, idx, inTable = false, highlightedRef, isHighlighted, renderNode}) => {
    if (!node) return null;

    console.log(idx)

    const firstIdx = findFirstPrefixTargetIndex(node?.content);
    const cls = (node?.content?.length > 0) ? `(${getClassificationFromChildren(node)})` : undefined;

    return (
        <li key={idx}>
            {(node.content || []).map((c, i) => (
                renderNode(c, [idx, i], {
                    inTable,
                    inListItem: true,
                    prefixText: i === firstIdx ? cls : undefined
                })
            ))}
        </li>
    );
};

